<template>
  <div>
    <div class="thumbnail">
      <div class="thumbnail-image" @click="onOpenVideo">
        <img
          class="thumbnail-image__src"
          v-show="thumbnail.url"
          :src="thumbnail.url"
          :alt="video.title"
        />
        <div class="thumbnail-image__overlay" />
        <img class="thumbnail-image__icon" src="../../assets/play-icon.svg" />
      </div>
      <div class="thumbnail-details">
        <h1>{{ video.title }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios';
import { SEGMENT_EVENTS } from '../../constants';

export default {
  name: 'VideoThumbnail',
  props: {
    video: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    thumbnail: {
      loading: true,
      url: '',
    },
    videoId: null,
  }),
  mounted() {
    if (this.video.url) {
      axios
        .get(`https://vimeo.com/api/oembed.json?url=${this.video.url}`)
        .then(response => {
          const { data } = response;
          this.videoId = data.video_id;
          this.thumbnail.url = data.thumbnail_url;
        })
        .finally(() => {
          this.thumbnail.loading = false;
        });
    }
  },
  methods: {
    ...mapActions(['setCurrentVideo']),
    onOpenVideo() {
      this.$router.push({
        name: 'Home | Video Modal',
        params: {
          id: this.video.id,
        }
      })
      this.setCurrentVideo({
        ...JSON.parse(JSON.stringify(this.video)),
        vimeoId: this.videoId,
      })
      window.analytics.track(SEGMENT_EVENTS.OPENED_VIDEO_MODAL, {
        contentTitle: this.video.title,
        contentId: this.video.id,
        contentType: 'Video Tutorials',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  display: flex;
  margin-bottom: 12px;

  @media (max-width: 1263px) {
    flex-direction: column;
    min-width: 222px;
    padding: 16px;
    background: white;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    height: 100%;
    margin-bottom: 0;
  }

  &-image {
    height: 120px;
    width: auto;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    margin-bottom: 12px;
    @media screen and (min-width: 960px) {
      height: 175px;
    }
    @media screen and (min-width: 1264px) {
      height: 130px;
      width: 190px;
    }
    @media screen and (min-width: 1904px) {
      height: 110px;
    }
    &__src {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-image__overlay {
    background: #1f3847;
    opacity: 0.6;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  &-image__icon {
    width: 17px;
    height: 25px;
    position: absolute;
    z-index: 1;
    top: calc(50% - 13px);
    left: calc(50% - 8px);
  }
  &-tags {
    flex-wrap: wrap;
    margin: 0 -8px 8px;
    &__item {
      padding: 4px 8px;
      background: #e6f5ed;
      font-size: 12px;
      font-weight: 500;
      line-height: 15px;
      color: #91a092;
      border-radius: 4px;
      margin: 8px;
    }
    @media screen and (max-width: 1264px) {
      margin: 0px 0px 8px 0px !important;
      &__item {
        margin: 0px;
      }
    }
  }
  &-details {
    flex: 1;
    flex-wrap: wrap;
    padding-left: 0px;
    h1 {
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      margin-bottom: 4px;
      color: var(--v-primary-base);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    p {
      font-size: 15px;
      font-weight: 500;
      line-height: 18px;
      color: #234025;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      margin: 0;
    }
    @media screen and (min-width: 1264px) {
      padding-left: 8px;
      margin-top: unset;
    }
  }
}
</style>
